import { useEffect } from "react";
import { DyteProvider, useDyteClient } from "@dytesdk/react-web-core";
import { useSearchParams } from "react-router-dom";

import { useMeeting } from "../../../../hooks/useMeeting";
import Meeting from "./meeting-components/Meeting";

export function Session() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const authToken = searchParams.get("authToken");

  if (!sessionId) {
    throw new Error("Session ID is required");
  }

  const data = useMeeting(sessionId);
  const [meeting, initMeeting] = useDyteClient();
  console.log("Session: ", sessionId, data);

  const conversationPrompts = [
    "Hey, how's everything going for you this week?",
    "I know quarter-end can be intense—how are you feeling about things right now?",
    "What's been the highlight of your week so far? And what's been the toughest part?",
  ];

  useEffect(() => {
    async function initializeMeeting() {
      if (!authToken) {
        alert(
          "An authToken wasn't passed, please pass an authToken in the URL query to join a meeting."
        );
        return;
      }
      const meeting = await initMeeting({
        authToken,
        defaults: { audio: false, video: false },
      });

      // Join the meeting
      if (meeting) {
        meeting.joinRoom();
      }
    }

    initializeMeeting();
  }, []);

  return (
    <DyteProvider value={meeting}>
      <Meeting
        sessionId={sessionId}
        conversationPrompts={conversationPrompts}
      />
    </DyteProvider>
  );
}
